type OneOnOneNoteFieldProps = {
  label: string;
  value: string;
};

const OneOnOneNoteField = ({ label, value }: OneOnOneNoteFieldProps) => (
  <div className="space-y-1">
    <p className="body-16-semibold">{label}</p>
    {value ? (
      <p className="body-14-regular whitespace-pre-line break-words text-neutral-200">
        {value}
      </p>
    ) : (
      <p className="body-14-regular text-neutral-50">—</p>
    )}
  </div>
);

export default OneOnOneNoteField;
